"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DeliveryAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getDeliverySettings(locationId) {
        return await this.client.get(`/delivery/v1/locations/${locationId}/settings`);
    }
    async updateDeliveryConfiguration(locationId, configurationUpdate) {
        return await this.client.patch(`/delivery/v1/locations/${locationId}/settings`, configurationUpdate);
    }
    async getLocationStatuses(filter) {
        return await this.client.get(`/delivery/v1/locations/statuses`, filter);
    }
    async getCartDeliveryInfo(cartId) {
        return await this.client.get(`/delivery/v1/carts/${cartId}/delivery-info`);
    }
    async getOrderDeliveryInfo(orderId) {
        return await this.client.get(`/delivery/v1/orders/${orderId}/delivery-info`);
    }
    async getDeliverableLocations(address, filter) {
        return await this.client.get(`/delivery/v1/locations/deliverable`, {
            ...address,
            ...filter,
        });
    }
}
exports.default = DeliveryAPI;
//# sourceMappingURL=index.js.map